import { z } from 'zod';

import { WidgetZod } from 'types/zod/widget';

const SimpleQuestionZod = z.object({
    _widget: WidgetZod.optional(),
    _on: z.string().optional(),
    _disabled: z.string().optional(),
    _name: z.string().optional(),
    _path: z.array(z.string()).optional(),
    _fullPath: z.array(z.string()).optional(),
    _section: z.string().optional(),
    _subsection: z.string().optional(),
    _isSectionStart: z.boolean().optional(),
    _help: z
        .object({
            conditional: z.boolean().optional(),
            state: z.boolean().optional(),
            product_code: z.boolean().optional(),
            state_groups: z.array(z.string()).optional(),
            new_participant: z.string().optional(),
            new_participant_address: z.string().optional(),
        })
        .optional(),
    _miro: z.object({ id: z.string().optional(), text: z.string().optional() }).optional(),
    _context: z.string().optional(),
    _fullContext: z.array(z.string()).optional(),
    _section_on: z.string().optional(),
    _default_answer: z
        .object({ use_if: z.string().optional(), value: z.string(), continue_after_set: z.string().optional() })
        .optional(),
});

const QuestionWithLoopZod = SimpleQuestionZod.extend({ _loop: z.array(SimpleQuestionZod).optional() });

export const QuestionZod = QuestionWithLoopZod.and(z.record(QuestionWithLoopZod)).and(z.record(z.any()));
export type Question = z.infer<typeof QuestionZod>;
